import { List, Map } from "immutable";
import { z } from "zod/v4";

import {
	type RunnableQuery,
	type RunnableQueryState,
	rawRunnableQueryStateSchema,
} from "../RunnableQuery";
import { type ZSet, rawZSetSchema } from "../ZSet";
import { querySpecSchema } from "../operatorsV2/QuerySpec";
import { type Action, rawActionSchema } from "./Action";

export interface QueryEvaluatorState {
	currentEpoch: number;
	tables: Map<string, ZSet<unknown>>;
	querySpecs: Map<string, RunnableQuery>;
	queryStates: Map<string, RunnableQueryState>;
	queryResults: Map<string, ZSet<unknown>>;
	actionLog: List<Action>;
	error: string | null;
}

//
// Zod schemas for JSON-serialized QueryEvaluatorState.
//

export const emptyQueryEvaluatorState = (): QueryEvaluatorState => ({
	currentEpoch: 0,
	tables: Map(),
	querySpecs: Map(),
	queryStates: Map(),
	queryResults: Map(),
	actionLog: List(),
	error: null,
});

export const errorQueryEvaluatorState = (error: Error): QueryEvaluatorState => ({
	currentEpoch: 0,
	tables: Map(),
	querySpecs: Map(),
	queryStates: Map(),
	queryResults: Map(),
	actionLog: List(),
	error: error.message,
});

export const rawQueryEvaluatorStateSchema = z.object({
	currentEpoch: z.number(),
	tables: z.record(z.string(), rawZSetSchema),
	querySpecs: z.record(z.string(), querySpecSchema),
	queryStates: z.record(z.string(), rawRunnableQueryStateSchema),
	queryResults: z.record(z.string(), rawZSetSchema),
	actions: z.array(rawActionSchema),
});
export type RawQueryEvaluatorState = z.infer<typeof rawQueryEvaluatorStateSchema>;
